// CertificateGallery.jsx
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./CertificateGallery.css"; // For custom styles
import axios from "axios";
import Particle from "../Particle";
import { Container } from "react-bootstrap";
import CertificateGallerySkeleton from "./CertificateGallerySkeleton";


const CertificateGallery = () => {
  const [popupData, setPopupData] = useState(null);
  const [certificates, setcertificates] = useState([]);
  const [galleryImages, setgalleryImages] = useState([]);
  const [isLoading, setIsloading] = useState(true);


  useEffect(() => {
    async function fetchAchievements() {
      try {
        const response = await axios.get(
          "https://portfolio-server-91pj.onrender.com/getTop10Achievements"
        );
        // Categorize the people based on isMale property
       await setcertificates(
            response.data
              .filter((person, index) => index<5)
              .map((person, index) => ({
                ...person,
                id: index+1
              }))
          );
        await  setgalleryImages(response.data);
        await setIsloading(false)

        console.log("Form submitted successfully:", galleryImages,certificates);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
    fetchAchievements();
  }, []);

  const GetMore = async ()=>{
    setIsloading(true)
    try {
        const response = await axios.get(
          "https://portfolio-server-91pj.onrender.com/getallAchievements"
        );
        // Categorize the people based on isMale property
       await setcertificates(
            response.data.reverse()
              .filter((person, index) => index<5)
              .map((person, index) => ({
                ...person,
                id: index+1
              }))
          );
        await  setgalleryImages(response.data);
        await setIsloading(false)

        console.log("Form submitted successfully:", galleryImages,certificates);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
  }

  const openPopup = (imageData) => {
    setPopupData(imageData);
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling
    });
  };

  const closePopup = () => {
    setPopupData(null);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <div className="headins">
    <Particle/>
     <h1 className="project-heading">
          My Recent <strong className="purple">Blogs</strong>
          {isLoading && <span> are Loading...</span>}
    </h1>
    { isLoading &&
            <CertificateGallerySkeleton />
    }
    { !isLoading &&
    <div className="gallery-container">
      <Slider {...sliderSettings} className="slider">
        {certificates.map((cert) => (
          <div key={cert.id} className="slide">
            <img src={cert.Image} alt={cert.Title} className="slide-image" onClick={() => openPopup(cert)} />
            <p className="caption">{cert.Title}</p>
          </div>
        ))}
      </Slider>

      <div className="grid-gallery">
        {galleryImages.map((img, index) => (
          <div key={index} className="grid-item" onClick={() => openPopup(img)}>
            <img
              src={img.Image}
              alt={`Gallery ${index}`}
              className="gallery-image"
            />
          </div>
        ))}
        {galleryImages.length<=10 && 
        <div className="grid-item white" onClick={() => GetMore()}>
            <p>View More</p>
        </div>
        }
      </div>

      {popupData && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-glass" onClick={(e) => e.stopPropagation()}>
            <img src={popupData.Image} alt="Popup" className="popup-image" />
            <div className="popup-description">
              <h3>{popupData.Title}</h3>
              <p>{popupData.subject}</p>
              { popupData.FindURL &&
              <a href={popupData.FindURL}>Find This Blog @ {popupData.FindAt}</a>
              }
            </div>
            <button className="close-btn-2" onClick={closePopup}>
              ✖
            </button>
          </div>
        </div>
      )}
    </div>
    }
    </div>
  );
};

export default CertificateGallery;
